import equal from 'fast-deep-equal';
import { useMemo, useRef } from 'react';

export const useStyle = (style: React.CSSProperties) => {
  const prev = useRef<React.CSSProperties>(style);

  if (!equal(prev.current, style)) {
    prev.current = style;
  }

  return useMemo(() => style, [prev.current]);
};
